module.exports = __webpack_public_path__ + "static/media/crash_1.8aedaf54.mp3";